var disabledSpecificDays = [];
var ph_plus_one = [];

var _date = $('#selectDate').val();

$(document).ready(() => {

  var _date =  $('#blackout_date').val().split(',');
  disabledSpecificDays = _date;
  // publicHolidayPlusOne();
  runDatepicker();

})

publicHolidayPlusOne = () => {
  var newDate = [];

  var td = new Date();
  var hourNow = td.getHours();

  // console.log('hournow', hourNow);
  // console.log(disabledSpecificDays, disabledSpecificDays.length);
  for (var i = 0; i < disabledSpecificDays.length; i++) {
    var _split = disabledSpecificDays[i].split('/');
    // console.log(disabledSpecificDays[i]);
    var _toparse = _split[2]+"-"+_split[1]+"-"+_split[0];
    var _d = moment(_toparse);
    var _d1 = _d.clone().add(1, 'd').format('DD/MM/YYYY');
    var _d2 = _d.clone().add(2, 'd').format('DD/MM/YYYY');
    var _d3 = _d.clone().add(3, 'd').format('DD/MM/YYYY');
    // console.log(_d.format('DD/MM/YYYY'), _d1);

    hourNow >=11 ? newDate.push(disabledSpecificDays[i],_d1,_d2,_d3) : newDate.push(disabledSpecificDays[i],_d1,_d2);
    ph_plus_one.push(_d1);
  }

  disabledSpecificDays = newDate;
}

getOurDateFormat = (_d) => {
  var year = _d.getFullYear(), month = _d.getMonth() + 1, day = _d.getDate();
  return day+"/"+month+"/"+year;
}

runDatepicker = () => {
  var d = new Date();
  var dayNow = d.getDay();
  // var newDate = new Date(d.setDate(d.getDate() + 1));
  var year = d.getFullYear(), month = ("0" + (d.getMonth() + 1)).slice(-2), day = ("0" + d.getDate()).slice(-2);
  var timeNow = d.getHours();

  var today_date = day+"/"+month+"/"+year;

  // console.log('today_date', today_date, '\nph_plus_one', ph_plus_one, '\nIs include', ph_plus_one.includes(today_date));

  /*
    Get current date, check if today it's public holiday/public holiday + 1
  */

  // Normal Day min and max date
  var _minDate = '+1';
  var _maxDate = '+6';

  if (timeNow >= 11) {
    _minDate = '+2';
    _maxDate = '+7';
    if (dayNow == 5 ) {
      _minDate = '+4';
      _maxDate = '+7';
    }
    else if (dayNow == 6 ) {
      _minDate = '+3';
      _maxDate = '+7';
    }
  }

  // PH min and max date
  if (disabledSpecificDays.includes(today_date)) {
      _minDate = '+3';
      _maxDate = '+9';
    // console.log('PH true');
  }
  else {
    if (dayNow == 0 ) {
      _minDate = '+2';
    }
    else if (dayNow == 6 ) {
      _minDate = '+3';
      _maxDate = '+7';
    }
  }

  // if (dayNow == 5) {
  //   if (timeNow >= 11 ) {
  //     console.log('runniing at here ?');
  //     _minDate = '+4';
  //   }
  // }
  // else if (dayNow == 6) {
  //   _minDate = '+3';
  // }
  // else if (dayNow == 0) {
  //   _minDate = '+2';
  // }
  // else {
  //   timeNow >= 11 ? _minDate = '+2' : _minDate = '+1' ;
  // }

  // console.log(_minDate, _maxDate,  "hi hee");

  $("#selectDate").datepicker({
    minDate: _minDate,
    maxDate: _maxDate,
    dateFormat: "dd/mm/yy",
    beforeShowDay: disableSpecificDaysAndWeekends
  });


  $("[name='checkout']").click(function() {
    var $this = $(this);

    if ($('#selectDate').val() == "" || $('#selectDate').val() === undefined)
    {
      document.querySelector('.date-error').style.display = "block";
      return false;
    } else {
      document.querySelector('.date-error').style.display = "none";
      $(this).submit();
      return true;
    }
  });
}

function getYMD(d) {
  const date = new Date(d)
  var year = date.getFullYear(), month = (date.getMonth() + 1), day = date.getDate()
  return `${month}-${day}-${year}`
}

function isDateDisabled(d) {
  const date = new Date(d)
  const day = date.getDay();
  if (day === 0) return true
  if (disabledSpecificDays.includes(getYMD(date))) return true
  if (new Date() > date) return true
  return false
}

function getAvailableDate(date) {
  let nextDate = new Date(date)
  while (isDateDisabled(nextDate)) {
    nextDate = new Date(nextDate.setDate(nextDate.getDate() + 1))
  }
  return nextDate
}

function disableSpecificDaysAndWeekends(d) {
  const date = new Date(d)
  var m = ("0" + (date.getMonth() + 1)).slice(-2);
  var d = ("0" + date.getDate()).slice(-2);
  var y = date.getFullYear();

  const day = date.getDay();
  // console.log(`${d}/${m}/${y}`);
  if (disabledSpecificDays.includes(`${d}/${m}/${y}`)) {
    return [false]
  }
  if (new Date() > date) {
    return [false]
  }
  return [(day != 0)]
}
